import type { List as FullList, Item, Product } from 'api/list/graphqlTypes';

export default /* GraphQL */ `
    fragment ListFields on List {
        updated
        quantity
        name
        isSelected
        listId
        items {
            itemNo
            quantity
            product {
                globalName
            }
        }
        designs {
            configurationId
        }
    }
`;

// This type represents the object above
export type List = Pick<
    FullList,
    'updated' | 'quantity' | 'name' | 'isSelected' | 'listId'
> & {
    items: Array<
        Pick<Item, 'itemNo' | 'quantity'> & {
            product: Pick<Product, 'globalName'>;
        }
    >;
};
